module.exports = __webpack_public_path__ + "static/media/recordatorio_cedimi.96e060df.png";